/**
 * Rating for below the recipe / hotspot / book
 */

// Import statements
import * as React from "react"
import {useState} from "react"
import {Rating} from 'react-simple-star-rating'
import {postCall} from "../react/api";
import parse from "html-react-parser";

/**
 * Define the RecipeRating constant
 * @param recipe
 * @returns {JSX.Element}
 * @constructor
 */
export const RecipeRating = ({recipe}) => {

    // get data & push array
    let post_ratings_average_rounded = Math.round(recipe.ratingsAverage * 2) / 2;
    //let stars = setStars( parseFloat(post_ratings_average_rounded) );

    // set standard rating
    const [rating, setRating] = useState(parseFloat(post_ratings_average_rounded) * 20)
    const [feedback, setFeedback] = useState('')

    // use function scope
    const wordpress_id = recipe.databaseId;

    // set the handleRating
    const handleRating = (rate) => {

        // set the rating in the state
        setRating(rate)

        // define the form data to be sent
        const formData = new FormData();
        formData.append("action", "add_recipe_rating");
        formData.append("nonce", 'myfoodblog');
        formData.append("id", wordpress_id);
        formData.append("rating", rate / 20);

        // make call
        const result = postCall(
            `${process.env.GATSBY_AJAX_URL}`,
            formData
        );

        // process the call
        result
            .then((resp) => resp.json())
            .then(function (data) {

                // show success message
                if (('users' in data) && ('average' in data)) {

                    // update the feedback message
                    setFeedback(parse(data.message ?? ''));

                    // add data attributes
                    setRating(data.average)

                    // show error message
                } else if ('message' in data) {

                    // update the feedback message
                    setFeedback(parse(data.message ?? ''));
                }

            })
    }

    // return the information
    return (
        <div id="rating">
            <p>Beoordeel dit recept</p>
            <div id="rating_value"><span>{parseFloat(post_ratings_average_rounded)}</span>/<span>5</span></div>
            <div id="stars" data-id={recipe.id}>
                <Rating
                    transition
                    onClick={handleRating}
                    ratingValue={rating}
                    initialValue={parseFloat(post_ratings_average_rounded) * 20}
                    size={20}
                    showTooltip
                    tooltipArray={['Dit was niet zo', 'Mwah', 'Het was oke', 'Lekker', 'Geweldig']}
                    tooltipDefaultText={`Jouw beoordeling`}
                    className={`star_icons_wrapper`}
                    tooltipClassName={`rating-tooltip`}
                    fillColor={`#15605c`}
                />
            </div>
            <div id="rating_count">
                {getRatingCount(recipe.ratingsUsers)}
            </div>
            <div id="stars_feedback">{feedback}</div>
        </div>
    )
}

/**
 * Define the HotspotRating constant
 * @param rating
 * @returns {JSX.Element}
 * @constructor
 */
export const HotspotRating = ({rating}) => {

    // how many stars do we have
    let stars = setStars(parseFloat(rating));

    // return the information
    return (
        <div id="rating">
            <h2>Eindoordeel</h2>
            <div id="stars">
                {stars}
                <StarLabels/>
            </div>
        </div>
    )
}

/**
 * Define the BookRating constant
 * @param rating
 * @returns {JSX.Element}
 * @constructor
 */
export const BookRating = ({rating}) => {

    // how many stars do we have
    let stars = setStars(parseFloat(rating));

    // return the information
    return (
        <div id="rating">
            <h2>Eindoordeel</h2>
            <div id="stars">
                {stars}
                <StarLabels/>
            </div>
        </div>
    )
}

/**
 * Export the RecipeRating variable
 */
export default RecipeRating

/**
 * Get the rating count
 * @param post_ratings_users
 * @returns {string}
 */
function getRatingCount(post_ratings_users) {
    if (post_ratings_users >= 2) {
        return '(' + post_ratings_users + ' beoordelingen)';
    } else if (post_ratings_users === 1) {
        return '(' + post_ratings_users + ' beoordeling)';
    } else if (post_ratings_users === "") {
        return '(0 beoordelingen)';
    }
}

/**
 * Set the stars
 * @param post_ratings_average_rounded
 * @returns {*[]}
 */
function setStars(post_ratings_average_rounded) {
    let stars = [];

    [1, 2, 3, 4, 5].forEach((val, index) => {

        // when the rating is identical to $i + 0.5, show half star
        if ((index - 1 + 0.5) === post_ratings_average_rounded) {
            stars.push(<input type="radio" id={`star${index + 1}`} name="rating" value={index + 1}
                              key={`rating-${index}`} checked={`checked`}/>)

            // when the rating is identical show full star
        } else if (index < post_ratings_average_rounded) {
            stars.push(<input type="radio" id={`star${index + 1}`} name="rating" value={index + 1}
                              key={`rating-${index}`} checked={`checked`}/>)

            // otherwise show empty star
        } else {
            stars.push(<input type="radio" id={`star${index + 1}`} name="rating" value={index + 1}
                              key={`rating-${index}`}/>)
        }
    });
    return stars;
}

/**
 * Export the StarLabels constant
 * @returns {JSX.Element}
 * @constructor
 */
export const StarLabels = () => {

    // return the information
    return (
        <div id="labelwrapper">
            <label htmlFor="star1" key={`star1`}>1 star</label>
            <label htmlFor="star2" key={`star2`}>2 stars</label>
            <label htmlFor="star3" key={`star3`}>3 stars</label>
            <label htmlFor="star4" key={`star4`}>4 stars</label>
            <label htmlFor="star5" key={`star5`}>5 stars</label>
        </div>
    )
}